import { render, staticRenderFns } from "./Killfeed.vue?vue&type=template&id=6c91923e&scoped=true&"
import script from "./Killfeed.vue?vue&type=script&lang=js&"
export * from "./Killfeed.vue?vue&type=script&lang=js&"
import style0 from "./Killfeed.vue?vue&type=style&index=0&id=6c91923e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c91923e",
  null
  
)

export default component.exports